import React, { useContext } from 'react';
import ProfileWrapper from './ProfileWrapper';
import BasicProfileInformation from './BasicProfileInformation';
import MapsSymbol from '../../assets/img/maps-symbol.png';
import PrimaryButton from '../buttons/PrimaryButton';
import RatingsHolder from './RatingsHolder';
import ClinicIcon from '../../assets/img/hospital-icon.png';
import { AuthContext } from '../context/Auth';
import ClinicRatingIcon from '../../assets/img/clinic-rating-icon.png';
import { WindowManagerContext } from '../context/WindowManager';
import axios from 'axios';
import config from '../../configuration';
import LoadingSkeleton from '../misc/LoadingSkeleton';
import { TrackingContext } from '../context/Tracking';
import RecommendationButton from '../buttons/RecommendationButton';

const MockedRating = props => {
  return (
    <RatingsHolder
      ratings={
        [
          {
            id: '77247',
            type: 'department',
            entity_id: '31301',
            clinic_id: '6994',
            category: 'einarbeitung',
            text: 'Es ging drunter und drüber',
            owner: 'Lüneborg@felixmedicus.de',
            source: 'l1734',
            recommended: -1,
            recommended_for: null,
            experience_time: '2018',
            perspective: 'PJ',
            createdAt: '2021-12-07T11:29:19.157Z',
            updatedAt: '2021-12-07T11:29:19.157Z'
          },
          {
            id: '77250',
            type: 'department',
            entity_id: '31301',
            clinic_id: '6994',
            category: 'arbeitszeiten',
            text: 'War OK',
            owner: 'Mann@felixmedicus.de',
            source: 'l6451',
            recommended: 0,
            recommended_for: null,
            experience_time: '2015',
            perspective: 'Famulatur',
            createdAt: '2021-12-07T11:29:19.157Z',
            updatedAt: '2021-12-07T11:29:19.157Z'
          },
          {
            id: '77249',
            type: 'department',
            entity_id: '31301',
            clinic_id: '6994',
            category: 'arbeitszeiten',
            text: 'Das Team wurde hier von den OÄ schlecht betreut',
            owner: 'Meier@felixmedicus.de',
            source: 'l6768',
            recommended: -1,
            recommended_for: null,
            experience_time: '2019',
            perspective: 'Assistent:in',
            createdAt: '2021-12-07T11:29:19.157Z',
            updatedAt: '2021-12-07T11:29:19.157Z'
          }
        ]
      }
      clinic={props.clinic}
    />
  );
};

const createProfileObject = (profilePieces) => {
  const profile = {};
  profilePieces.forEach(profilePiece => {
    const key = profilePiece.position;
    if (Object.keys(profile).includes(key)) {
      profile[key].push(profilePiece);
    } else {
      profile[key] = [profilePiece];
    }
  });
  console.log(profile);
  return profile;
};

const DepartmentProfile = props => {
  const { openWindow } = useContext(WindowManagerContext);
  const { t, ratingViewsAllowed, trackingActive } = useContext(TrackingContext);
  const { id } = props.department;
  const [ratings, setRatings] = React.useState([]);
  const [profile, setProfile] = React.useState({});
  const [loadingRatings, setLoadingRatings] = React.useState(true);
  const [department, setDepartment] = React.useState({ name: props.department.name || '' });
  const ALLOWED = props.clinic?.status === 1 || ratingViewsAllowed || ratings.length === 0;

  const getRating = () => {
    if (id) {
      axios.get(config.backendAddress + '/open/getRatings?departmentId=' + id)
        .then(result => {
          setRatings(old => result.data);
          setLoadingRatings(false);
        });
    }
  };

  const getDepartmentInfo = id => {
    if (id) {
      axios.get(config.backendAddress + '/open/getDepartments?basic=true&departmentId=' + id)
        .then(result => {
          console.log(result.data);
          setDepartment(old => result.data);
        });
      axios.get(config.backendAddress + '/open/getProfile?type=department&entityId=' + id)
        .then(result => {
          setProfile(old => createProfileObject(result.data));
        });
    }
  };

  React.useEffect(() => {
    getRating();
    if (department.id !== id) {
      getDepartmentInfo(id);
    }
  }, [id]);

  return (
    <>
      <ProfileWrapper
        width={470}
        height={700}
        backLabel={<img src={ClinicIcon} width={20} />}
        back={() => props.openClinic()}
        open={() => {
          if (props.onlyOneSubjectArea) {
            props.open(false);
          } else {
            props.openClinic();
          }
        }}
      >
        <div>
          <BasicProfileInformation
            {...props}
            backLabel={<img src={ClinicIcon} width={20} />}
            back={() => props.openClinic()}
            recommendationComponent={<></>}
            title={department.name || 'Lädt die Abteilung'}
            subtitle={props.clinic.name || 'Klinik...'}
            informationList={[
              ...(department.attending
                ? [{
                    icon: <img src={ClinicIcon} width={12} />,
                    info: <p>Belegabteilung</p>
                  }]
                : []
              )
            ]}
          />
          {
            ALLOWED && (
              <RecommendationButton
                clinic={props.clinic}
                department={department}
              />
            )
          }
        </div>

        <div style={{ clear: 'both', marginTop: 60 }}>
          {
          ALLOWED
            ? (
              <>
                {
                !loadingRatings
                  ? (
                    <>
                      <RatingsHolder
                        ratings={ratings}
                        clinic={props.clinic}
                        department={department}
                      />
                    </>
                    )
                  : (
                    <>
                      <LoadingSkeleton style={{ marginTop: 100, marginLeft: 60 }} />
                    </>
                    )
              }
                {/* <div className='clinic-ratings-wrapper'>
                  <br />
                  <h2 style={{ fontWeight: 'bold' }}>Was sagt die Abteilung über sich?</h2>
                  <br />
                  {
                      profile[1].map(profilePiece => {
                        return (
                          <React.Fragment key={profilePiece.id}>
                            <h4>
                              <b>{profilePiece.headline}</b>
                            </h4>
                            <p>{profilePiece.html}</p>
                          </React.Fragment>
                        );
                      })
                  }
                </div> */}
              </>
              )
            : (
              <div style={{ position: 'relative' }}>
                <div className='blurry-content'>
                  <MockedRating clinic={props.clinic} />
                </div>
                <div className='provide-rating'>
                  <div style={{ width: '100%', height: 1, marginTop: 10 }} />
                  <div className='red-box'>
                    <img src={ClinicRatingIcon} width={50} />
                    <h6>Möchtest du die Bewertungen sehen?</h6>
                    {
                      !trackingActive
                        ? (
                          <p>Dadurch, dass deine <b>Cookies nicht aktiviert</b> sind, kannst du Bewertungen nur sehen, wenn du selbst eine Bewertung abgibst.<br />
                            <i>Aktiviere <a style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => openWindow('chooseCookie')}>hier</a> deine Cookies und du kannst ohne Bewertungsabgabe 2 Bewertungen sehen.</i>
                          </p>
                          )
                        : (
                          <p>Um die nächste Bewertung zu sehen, musst du selbst eine Klinik bewerten, in der du gearbeitet hast (PJ, Assistenzarztzeit).<br />
                            <i>Nur so können wir auf Dauer alle Arbeitsbedingungen transparent machen und ALLEN helfen.</i>
                          </p>
                          )
                    }
                    {/* <p>Wenn du die Bewertungen einsehen möchtest, musst du selbst eine Klinik bewerten, in der du gearbeitet hast (PJ, Assistenzarztzeit).<br />
                      <i>So können wir auf Dauer alle Arbeitsbedingungen transparent machen.</i>
                    </p> */}
                    <PrimaryButton scale={1.1} className='smaller' style={{ maxWidth: 250, float: 'right' }} onClick={() => { t('action', 'no_rating_create_rating_button'); openWindow('createRating', { reason: 'unlock' }); }}>Bewertungen freischalten</PrimaryButton>
                    <div style={{ clear: 'both' }} />
                    <a onClick={() => { t('action', 'no_rating_has_profile'); openWindow('login', {}); }} style={{ float: 'right', textDecoration: 'underline', marginRight: 12, marginTop: 2, cursor: 'pointer' }}>Du hast schon einen Account?</a>
                    <div style={{ clear: 'both' }} />
                  </div>
                </div>
              </div>
              )
        }
        </div>
      </ProfileWrapper>
    </>
  );
};

export default DepartmentProfile;
